'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _recompose = require('recompose');
var _playlistItemContainer = require('../playlistItem/playlistItemContainer');
var _playlistItemContainer2 = _interopRequireDefault(_playlistItemContainer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Playlist = function Playlist(_ref) {
  var playlist = _ref.playlist,
    children = _ref.children,
    className = _ref.className;
  return _react2.default.createElement('ul', {
    className: className
  }, playlist.map(function (media, index) {
    return _react2.default.createElement(_playlistItemContainer2.default, {
      key: media.id,
      index: index
    }, children);
  }));
};
Playlist.propTypes = {
  className: _propTypes2.default.string.isRequired,
  playlist: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string,
    artist: _propTypes2.default.string,
    sources: _propTypes2.default.object.isRequired,
    poster: _propTypes2.default.string,
    id: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.number.isRequired]).isRequired,
    free: _propTypes2.default.bool
  })).isRequired,
  children: _propTypes2.default.node.isRequired
};
exports.default = (0, _recompose.compose)((0, _recompose.branch)(function (props) {
  return props.playlist.length > 0;
}, (0, _recompose.renderComponent)(Playlist)))((0, _recompose.renderNothing)(null));